import { isRequestError } from 'utils/requestError';
import { InputText, Loading, PopupWraper } from 'components';
import { Button, InputWraper, useForm } from 'modules';
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';

import { formSchema } from './config';
import { useSubmitRefferalMutation } from 'services/auth/mutations/useSubmitRefferalMutation';

type Props = {
  isOpen: boolean;
  isLoadingProcess?: boolean;
  onSuccess: ({ refferalCode }: { refferalCode: string }) => void;
  onClose: () => void;
};

const ModalRefferal = (props: Props) => {
  const { isOpen, onSuccess, onClose, isLoadingProcess = false } = props;

  const [isShowPopup, setIsShowPopup] = useState<boolean>(isOpen);

  const { mutateAsync, isLoading } = useSubmitRefferalMutation();

  const { handleSubmit: handleSubmitModal, getInputProps: getInputPropsModal } =
    useForm({
      structure: formSchema,
      onSubmit: handleCheckPinCode,
    });

  useEffect(() => {
    setIsShowPopup(isOpen);
  }, [isOpen]);

  async function handleCheckPinCode(values: any) {
    const { refferalCode } = values;

    try {
      const dataCheckPinCode = await mutateAsync({ referrerId: refferalCode });
      if (dataCheckPinCode) {
        toast.success('Bạn đã nhập mã giới thiệu thành công');
        return onSuccess({ refferalCode });
      }

      // throw dataCheckPinCode;
    } catch (error: any) {
      console.error(error);
      if (!isRequestError(error)) {
        toast.error(String(error?.message) || 'Xác thực không thành công');
      }
    }
  }

  if (!isShowPopup) return <></>;

  return (
    <PopupWraper
      center
      title='Nhập mã giới thiệu'
      onClose={() => {
        setIsShowPopup(false);
        onClose();
      }}
    >
      <form onSubmit={handleSubmitModal} className='charge-bill-container'>
        <Loading isLoading={isLoading || isLoadingProcess}>
          <div className='charge-bill__title'>
            <InputWraper
              label='Mã giới thiệu'
              inputProps={getInputPropsModal('refferalCode')}
              component={InputText}
            />
          </div>
          <div className='charge-bill__button-container'>
            <Button
              className='button__confirm mr5'
              label='Xác nhận'
              buttonType='success'
              type='submit'
            />
            <Button
              className='button__cancel ml5'
              onClick={() => {
                setIsShowPopup(false);
                onClose();
              }}
              label='Tiếp tục'
              buttonType='primary-outline'
            />
          </div>
        </Loading>
      </form>
    </PopupWraper>
  );
};

export default ModalRefferal;
